import { Component } from '@angular/core';

@Component({
    selector: 'productdetailapp',
    template: ` <router-outlet></router-outlet> `,
})
export class ProductDetailComponent {}
